import { type JSX } from 'react';

import { createFileRoute } from '@tanstack/react-router';

import { BenchmarkingDetailedAnalysis } from '@/features/benchmarking';

export const Route = createFileRoute('/microdados/analise-detalhada')({
  component: BenchmarkingAnaliseDetalhadaTab,
});

function BenchmarkingAnaliseDetalhadaTab(): JSX.Element | null {
  return <BenchmarkingDetailedAnalysis />;
}
